import { render, staticRenderFns } from "./IV.vue?vue&type=template&id=03f3876f&"
import script from "./IV.vue?vue&type=script&lang=js&"
export * from "./IV.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports